var _path, _path2, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYearlyPerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12a9 9 0 1 1-6.219-8.56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3v6h-6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 11,
    x2: 8,
    y2: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 9,
    x2: 12,
    y2: 15
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 13,
    x2: 16,
    y2: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYearlyPerformance);
export default __webpack_public_path__ + "static/media/yearly_performance.77e8918fc230115268dd0c249c8f4bcc.svg";
export { ForwardRef as ReactComponent };